import { render } from "./announcement-banner.vue?vue&type=template&id=599b7660"
import script from "./announcement-banner.vue?vue&type=script&lang=js"
export * from "./announcement-banner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__